export const encode = data => '?' + new URLSearchParams(data).toString();
